import { CrumbClickFunc } from "@amzn/stencil-react-components/breadcrumbs";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

export const useCrumbClick = (): CrumbClickFunc => {
  const history = useHistory();

  return useCallback(
    (event, crumb) => {
      event.preventDefault();
      if (!crumb.url) {
        return;
      }
      if (crumb.url.startsWith("http")) {
        window.location.href = crumb.url;
      } else {
        history.push(crumb.url);
      }
    },
    [history],
  );
};
